import React from 'react';

import { ButtonTheme } from '@imgly/imgly-website-components';

import { Links } from '../../utils/constants';
import { LinkButton } from '../LinkButton';

import * as classes from './style.module.scss';

interface Props {
  pricing?: boolean;
}
// todo: update text and buttons
export const CallToAction: React.FC<Props> = ({ pricing }) => (
  <section className={classes.section}>
    <div className={classes.root}>
      <div className={classes.text}>
        <div className={classes.headline}>Ready to get started?</div>
        <span className={classes.paragraph}>
          With a free trial and pricing that fits your needs, it&apos;s easy to
          find the best solution for your product.
        </span>
      </div>
      <div className={classes.buttons}>
        <LinkButton
          aria-label="Go to our pricing page"
          href={Links.FreeTrial.url}
          data-analytics={Links.FreeTrial.analyticsID}
          theme={ButtonTheme.Primary}
        >
          {Links.FreeTrial.name}
        </LinkButton>
        {pricing && (
          <LinkButton
            aria-label="Go to our pricing page"
            href={Links.Pricing.url}
            data-analytics={Links.Pricing.analyticsID}
            theme={ButtonTheme.Secondary}
          >
            {Links.Pricing.name}
          </LinkButton>
        )}
      </div>
    </div>
  </section>
);
